import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect } from "react";
import {useFormik} from "formik";
import * as yup from "yup";
import "./EditSettings.scss";
import TextEditor from "../../components/TextEditor/TextEditor";
import TextEditorReader from "../../components/TextEditorReader/TextEditorReader";
import PageLayout from "../../components/PageLayout/PageLayout";
import SettingsActions from "../../api/SettingsActions";
import {useNotification} from "../../hooks/useNotification";
import {settingsIcon} from "../../components/Icon/Icon";

const validationSchema = yup.object({
    subject: yup.string()
        .trim("Subject cannot be empty spaces")
        .required("Subject is required"),
    body: yup.string()
        .trim("Message body cannot be empty spaces")
        .required("Message body is required")
});

const EditSettings = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const {triggerNotification} = useNotification();

    const formik = useFormik({
        initialValues: {
            name: "",
            body: "",
            subject: "",
            company: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            values.body = values.body.replace(values.company,"[your_company]")
            values.subject = values.subject.replace(values.company, "{[your_company]}")
            const payload = {
                name: values.name,
                body: values.body,
                subject: values.subject
            };

            SettingsActions.updateEmail(id, payload, () => {
                triggerNotification("Changes were saved successfully")
                navigate("/settings")
            })
        }
    })

    useEffect(() => {
        if(!id) return

        SettingsActions.getEmail(id, (response) => formik.setValues(response))
    }, [id]);

    return (
        <PageLayout
            icon={settingsIcon}
            titlePage="Settings"
            titlePageContent={formik.values.name}
            actions={
                <>
                    <Button type="submit" form="settingsForm">
                        Save
                    </Button>
                    <Button to="/settings" variant="secondary">
                        Close
                    </Button>
                </>
            }
            className='edit-settings'
        >
            <form id="settingsForm" onSubmit={formik.handleSubmit}>
                <Input
                    name="subject"
                    label="Subject"
                    className="modal"
                    value={formik.values.subject.replace("{[your_company]}", formik.values.company)}
                    formik={formik}
                    required={false}
                />

                <TextEditor
                    value={formik.values.body.replace("[your_company]", formik.values.company)}
                    onTextChange={(newContent) => formik.setFieldValue("body", newContent)}
                    onBlur={formik.handleBlur}
                    error={formik.touched.body ? formik.errors.body : null}
                />

                <div className="preview">
                    <p>Preview</p>
                    <hr />
                    <p>Subject: {formik.values.subject.replace("{[your_company]}", formik.values.company)}</p>
                    <TextEditorReader text={formik.values.body.replace("[your_company]", formik.values.company)}/>
                </div>
            </form>
        </PageLayout>
    )
}

export default EditSettings;